/* PUPS RTL: Dawn's slider counts pages with offsetLeft, which runs backwards
   in a right-to-left layout. Use the absolute distance instead.
   Replaces the Sense RTL app's slider patch (21.10.2026). */
(function () {
  if (typeof SliderComponent === 'undefined') return;
  SliderComponent.prototype.initPages = function () {
    if (!this.sliderItems) return;
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((el) => el.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    const first = this.sliderItemsToShow[0];
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - first.offsetLeft;
    this.slidesPerPage = Math.floor(Math.abs((this.slider.clientWidth + first.offsetLeft) / this.sliderItemOffset));
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  };
})();
